import { CLEAR_RECTIFICATION, SET_RECTIFICATION } from '../constants/ActionTypes'
import { push } from 'connected-react-router'
import { isPartiallyShippingRestricted } from '../selectors/getShippingRestrictions'
import { setCheckoutNotification } from './checkoutNotification'
import type { ShoppingCart } from 'app/types/common-types'
import type { Dispatch } from 'redux'

type SetRectificationProps = {
    redirect?: string;
    error?: any;
    payload: CartResponse;
    rectificationType: 'RECTIFY_OUT_OF_STOCK' | 'RECTIFY_SHIPPING_RESTRICTION' | 'RESERVATION_NUMBER_INVALID' | 'CART_LIMIT_QTY_REDUCED'
    affectedItems?: number
}

type CartResponse = {
    shoppingCart: ShoppingCart
}

export const RECTIFY_OUT_OF_STOCK = 'RECTIFY_OUT_OF_STOCK'
export const RECTIFY_SHIPPING_RESTRICTION = 'RECTIFY_SHIPPING_RESTRICTION'
export const RESERVATION_NUMBER_INVALID = 'RESERVATION_NUMBER_INVALID'
export const CART_LIMIT_QTY_REDUCED = 'CART_LIMIT_QTY_REDUCED'

export const clearRectification = () => (dispatch) =>
    dispatch({
        type: CLEAR_RECTIFICATION,
    })

export const setRectification = ({ redirect, error, payload, rectificationType, affectedItems }: SetRectificationProps) => ({
    type: SET_RECTIFICATION,
    rectificationType,
    redirect,
    error,
    payload,
    affectedItems,
})

export const ORDER_MESSAGE_ALLOWLIST = [
    'PAYMENT_METHOD_INVALID_COD_LIMIT',
    'PAYMENT_METHOD_INVALID_COD_LOCATION',
    'bagUpdated',
    'CART_ITEM_INVALID',
    'CART_MERGED',
]
export const showNotificationIfNeeded = (dispatch: Dispatch, cart: CartResponse) => {
    const [rectifier] = (cart.shoppingCart?.orderMessages || []).filter((orderMessage) => {
        return ORDER_MESSAGE_ALLOWLIST.includes(orderMessage.code)
    })
    if (rectifier) {
        // @ts-ignore
        dispatch((dispatch, getState) => {
            const { messages } = getState()
            const messageFn = messages.cartRectification[rectifier.code]
            if (messageFn) {
                dispatch(setCheckoutNotification('info', messageFn(), { autoHideDelay: 8000, sticky: true }))
            }
        })
    }
}

export const checkRectificationOnSuccess = (dispatch: Dispatch, cartResponse: CartResponse, redirect?: string) => {
    const { shoppingCart: { removedItems, orderItem = [], orderMessages = [] } = {} } = cartResponse
    if (orderMessages.find((el) => el.code === RESERVATION_NUMBER_INVALID)) {
        dispatch(setRectification({ redirect, payload: cartResponse, rectificationType: RESERVATION_NUMBER_INVALID }))
    } else if (orderMessages.find((el) => el.code === CART_LIMIT_QTY_REDUCED) && removedItems) {
        dispatch(setRectification({ redirect, payload: { ...cartResponse }, affectedItems: removedItems.length, rectificationType: CART_LIMIT_QTY_REDUCED }))
    } else if (removedItems?.length) {
        dispatch(setRectification({ redirect, payload: cartResponse, rectificationType: RECTIFY_OUT_OF_STOCK }))
    } else if (isPartiallyShippingRestricted(orderItem)) {
        dispatch(setRectification({ redirect, payload: cartResponse, rectificationType: RECTIFY_SHIPPING_RESTRICTION }))
    } else if (redirect) {
        dispatch(push(redirect))
    }
    showNotificationIfNeeded(dispatch, cartResponse)
}

export const checkRectificationOnError = async (error, dispatch) => {
    const { response } = error

    if (response && response.json) {
        try {
            const data = await response.clone().json()
            checkRectificationOnSuccess(dispatch, data)
        } catch {
            // continue regardless of error
        }
    }
}
